<template>
  <div class="container">
      <NavbarSimple :leftText="$t('common.notificationAndFAQ')"></NavbarSimple>
      <van-tabs>
        <van-tab title-style="font-weight:bold;" :title='$t("common.FAQ")'>
            <div class="list">
                <div class="item" v-for="elem of FAQs" :key="elem.id" @click="unfoldId = elem.id">
                    <van-icon name="question-o" size="8rem"/>
                    <div>
                        <span class="title">{{elem.title}}</span>
                        <span class="updateAt">{{elem.updatedAt}}</span>
                        <div v-if="unfoldId === elem.id" v-html="elem.content" style="word-break: break-all;"></div>
                    </div>
                </div>
            </div>
        </van-tab>
        <van-tab title-style="font-weight:bold;" :title='$t("common.notification")'>
            <div class="list">
                <div class="item" v-for="elem of data" :key="elem.id" @click="unfoldId = elem.id">
                    <van-icon name="bullhorn-o" size="8rem"/>
                    <div>
                        <span class="title">{{elem.title}}</span>
                        <span class="updateAt">{{elem.updatedAt}}</span>
                        <div v-if="unfoldId === elem.id" v-html="elem.content" style="word-break: break-all;"></div>
                    </div>
                </div>
            </div>
        </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import NavbarSimple from '@/components/NavbarSimple.vue'
export default {
    name: 'notification',
    components: {
        NavbarSimple
    },
    data() {
        return {
            data: [],
            unfoldId: null,
            FAQs: []
        }
    },
    mounted() {
        this.token = localStorage.getItem('token');
        this._fetch();
        this.FAQs = this.$t('common.FAQs').map(elem => {
            elem.content = elem.content.replace(/\r?\n/g, '<br>');
            elem.content = elem.content.replace(/\s/g, '&nbsp;');
            return elem;
        });
    },
    methods: {
        _fetch() {
            this.apiV1({
                method: 'get',
                url: '/notification',
                headers: {'Authorization': this.token}
            }).then(response => {
                const { success, data } = response.data;
                if (success) {
                    this.data = data.map(elem => {
                        elem.content = elem.content.replace(/\r?\n/g, '<br>');
                        elem.content = elem.content.replace(/\s/g, '&nbsp;');
                        return elem;
                    });
                }
            })
        }
    }
}
</script>

<style scoped lang="less">
.list {
    background-color: @app-theme-color4;
    border-radius: 5.333rem;
    padding: 4rem;
    border: 0.267rem solid @app-theme-color1;
    overflow: auto;
    .item {
        display: flex;
        align-items: center;
        padding: 4rem 3.888rem;
        background-color: #d6b593;
        border-radius: 3.888rem;
        color: #fffce3;
        border: 0.267rem solid @app-theme-color1;
        >div {
            margin-left: 3.888rem;
            display: flex;
            flex-direction: column;
            .title {
                font-weight: bold;
                color: @app-theme-color1;
            }
            .updateAt {
                font-size: 3.467rem;
            }
        }
    }
    .item + .item {
        margin-top: 8px;
    }
}
</style>